// extracted by mini-css-extract-plugin
export default {"steps":"formSteps_steps__s1pNc","numberLabel":"formSteps_numberLabel__1fr1E","activeStep":"formSteps_activeStep__-kxOE"};